export default {
  title: 'Restauracje testowe',
  description:
    'Każdy partner może oznaczyć jedną restaurację jako testową. Działa jak każda inna restauracja i nigdy nie jest rozliczana. Alert na Slacku jest wysyłany, gdy jej miesięczna sprzedaż przekroczy próg.',
  empty: 'Żaden partner nie ma restauracji testowej.',
  columns: {
    partner: 'Partner',
    restaurant: 'Restauracja',
    designated: 'Oznaczono jako test',
    gmv: 'GMV w tym miesiącu',
  },
  statuses: {
    live: 'Na żywo',
    paused: 'Offline',
    suspended: 'Zawieszona',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Brak zapisanego kursu wymiany',
  },
  actions: {
    remove: 'Usuń oznaczenie Test',
  },
  toasts: {
    load_error: 'Nie udało się wczytać restauracji testowych.',
  },
};
